import { api } from '@/lib/api';

export const manualApi = {
  library: () => api.get('/manual/sources').then((r) => r.data),
  source: (id) => api.get(`/manual/sources/${id}`).then((r) => r.data),
  addSource: (origin) => api.post('/manual/sources', origin).then((r) => r.data),
  prepare: (id) => api.post(`/manual/sources/${id}/prepare`).then((r) => r.data),
  grant: (id) => api.post(`/manual/sources/${id}/playback-grant`).then((r) => r.data),
  exports: () => api.get('/manual/exports').then((r) => r.data),
  project: (id) => api.get(`/manual/exports/${id}`).then((r) => r.data),
  export: (body) => api.post('/manual/exports', body, { timeout: 30000 }).then((r) => r.data),
};

export function manualError(error) {
  const detail = error.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (error.response?.status === 422) return 'Check the clip titles and time ranges, then try again.';
  if (error.response?.status === 401) return 'Please sign in again to access your saved videos.';
  return 'The connection was interrupted. Your saved videos and completed clips are unchanged. Please retry.';
}

export function timecode(seconds) {
  const value = Math.max(0, Math.round(Number(seconds || 0) * 1000));
  const hours = Math.floor(value / 3600000), minutes = Math.floor(value / 60000) % 60;
  const secs = ((value % 60000) / 1000).toFixed(3).padStart(6, '0');
  return hours ? `${hours}:${String(minutes).padStart(2, '0')}:${secs}` : `${String(minutes).padStart(2, '0')}:${secs}`;
}

export function parseTime(value) {
  if (!/^\d+(?::\d{1,2}){0,2}(?:\.\d{1,3})?$/.test(String(value))) return NaN;
  const parts = String(value).split(':').map(Number);
  if (parts.slice(1).some((part) => part >= 60)) return NaN;
  return parts.reduce((total, part) => total * 60 + part, 0);
}

export function selectionError(start, end, duration) {
  if (!Number.isFinite(start) || !Number.isFinite(end)) return 'Use seconds or a timecode such as 01:23.500.';
  if (start < 0 || end > duration + .02) return 'Keep the selection inside the source video.';
  if (end - start < 1 || end - start > 180) return 'Choose a range between 1 second and 3 minutes.';
  return '';
}
